import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

import App from './App.tsx';
import { consumeBasePortalHandoff } from './lib/auth.ts';
import { queryClient } from './lib/query.ts';
import './index.css';

// Before React mounts and before the router reads the location (§6.7): a token left in the address
// bar even briefly reaches history, access logs and `Referer`, and none of that comes back.
consumeBasePortalHandoff();

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
